module.exports = __webpack_public_path__ + "162f944a62a997e428452e390ccdf81d.svg";